import React, { ReactNode } from 'react';
import classNames from 'classnames';
import Tooltip from 'Douleutaras/components/Tooltip/Tooltip';
import infoIcon from 'Assets/layout/jobPage/infoСircle.svg';

import './CustomLabel.scss';

export interface CustomLabelProps {
  title: ReactNode | string;
  subtitle?: string;
  id?: string;
  required?: boolean;
  regular?: boolean;
  styleName?: string; // This translates to className
  className?: string;
  requiredText?: string;
  short?: boolean; // short margin bottom
  tooltip?: string;
}

export const CustomLabel: React.FC<CustomLabelProps> = props => {
  const { className, regular, requiredText = '*', short = false, title, subtitle, id, required = false, tooltip } = props;

  const styleName = classNames({
    'custom-label': true,
    'custom-label--regular': regular,
    'custom-label--required': !requiredText && required,
    'custom-label--short':  short,
    'custom-label--no-margin': Boolean(subtitle),
    'custom-label--with-tooltip': Boolean(tooltip)
  });

  const Content = () => (
    <>
      <div styleName="custom-label__main">
        { title }
        { requiredText?.length > 0 && required && <span styleName="custom-label__is-required">&nbsp;{requiredText}</span> }
        { Boolean(subtitle) &&
          <span styleName={classNames('custom-label__subtitle', { 'custom-label__subtitle--short': short })}>
            {subtitle}
          </span>
        }
      </div>
      { Boolean(tooltip) &&
        <div>
          <Tooltip content={tooltip} direction="top">
            <img styleName="custom-label__tooltip" src={infoIcon} alt="info icon" />
          </Tooltip>
        </div>
      }
    </>
  );

  if (!id) {
    return (
      <div
        styleName={styleName}
        className={className}
      >
        { Content() }
      </div>
    );
  }

  return (
    <label
      htmlFor={id}
      styleName={styleName}
      className={className}
    >
      { Content() }
    </label>
  );
};
